import React, { useState, useEffect } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { useMatch } from 'react-router-dom'
import { commonActions } from '../../actions/commonActions';
import * as commonSelectors from './selectors'
import Loader from './loader/Loader';

const Authorize = () => {
    const match = useMatch('clientapp/authorize/:redirectUri');
    const [loading, setLoading] = useState(false);
    const isAuthorizedSelector = useSelector(commonSelectors.isAuthorized);
    const dispatch = useDispatch();

    useEffect(() => {
        const _isAuthorized = isAuthorizedSelector ?? false;

        if (_isAuthorized) {
            setLoading(false);
            const _redirectUri = match.params.redirectUri.replace(/xr-/g, '/');
            
            commonActions.history.push(_redirectUri);
        } else {
            setLoading(true);
            dispatch(
                commonActions.checkSession()
            );
        }
    }, [isAuthorizedSelector, match.params.redirectUri, dispatch]);

    return (
        <Loader
            isloading={loading}
        />
    );
}


export default Authorize;